import React from 'react';
import { BannerTerms } from '../BannerTerms';
import { OffersDataService } from '../../../../services/offers-data.service';
import { BannerCtaContainer } from '../BannerCtaContainer';

export const DefaultBannerLayout = ({ bannerAction, isPayNPlayEnabled }) => {
    const { description, image, mainBannerLayout } =  OffersDataService.getOffersData();

    return (<>
        <div className={`homepage-banner-wrapper ${mainBannerLayout}`}>
            <div className="homepage-banner-right-section">
                <img
                    src={image}
                    alt="Banner"
                    loading="lazy"
                    onClick={bannerAction}
                    className="homepage-banner-image"/>
            </div>

            <div className="homepage-banner-left-section">
                <div className={`homepage-banner-left-section__wrapper ${mainBannerLayout}`}>
                    <div className="banner-info-container">
                        <p
                            className={`homepage-banner-title ${mainBannerLayout}`}
                            dangerouslySetInnerHTML={{ __html: description }}>
                        </p>

                        <BannerCtaContainer
                            ctaClassName="homepage-banner-cta"
                            isPayNPlayEnabled={isPayNPlayEnabled}
                            bannerAction={bannerAction}
                        />

                        <BannerTerms className="homepage-banner-terms" />
                    </div>
                </div>
            </div>
        </div>
    </>);
};
